import { render, staticRenderFns } from "./childFollowup.vue?vue&type=template&id=209dafaa"
import script from "./childFollowup.vue?vue&type=script&lang=js"
export * from "./childFollowup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports